export { default as noResult } from "./no-result";
export { default as withResults } from "./with-results";

export { default as offerOnline } from "./offer-online";
export { default as offerPlaces } from "./offer-places";
